import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ErrorDoalogConfig } from '../models/error-dialog-model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgTemplateOutlet } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: true,
    imports: [CdkScrollable, MatDialogContent, NgTemplateOutlet, MatDialogActions, MatButton, TranslateModule]
})
export class ErrorModalComponent {
  data = inject<ErrorDoalogConfig>(MAT_DIALOG_DATA);
  dialog = inject<MatDialogRef<ErrorModalComponent>>(MatDialogRef);


  /**
   * closes the error popup shown on the screen and return false
   */
  cancel() {
    this.dialog.close(false);
  }
}
